var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 4,
    viewBox: "0 0 8 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00002 4C3.86973 4 3.74002 3.956 3.6343 3.86742L0.205666 1.01007C-0.0366241 0.808341 -0.0697675 0.447744 0.132522 0.205441C0.33424 -0.0368624 0.694247 -0.0694362 0.937108 0.132293L4.00631 2.69019L7.07037 0.224299C7.31609 0.0265708 7.67609 0.0654307 7.87381 0.311163C8.07153 0.556895 8.03267 0.916349 7.78695 1.11465L4.35832 3.87371C4.25374 3.95771 4.12688 4 4.00002 4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.0599f52e29b56b70a617078768a105c2.svg";
export { ForwardRef as ReactComponent };